module.exports = __webpack_public_path__ + "img/new_empty.c4086fb2.png";